import * as mutationTypes from './mutationTypes';
import {CAMPAIGN_QUALIFICATION_STATUS} from "../../helpers/campaigns/constants";

const mutations = {
  [mutationTypes.FETCH_NUMBERS](state) {
    state.fetchingNumbers = true;
    state.errorFetchingNumbers = undefined;
  },

  [mutationTypes.DONE_FETCHING_NUMBERS](state, { numbers = [] }) {
    state.numbersMap = numbers.reduce(
      (acc, number) => ({
        ...acc,
        [number.phoneNumber]: number,
      }),
      {}
    );
    state.fetchingNumbers = false;
  },

  [mutationTypes.ERROR_FETCHING_NUMBERS](state, { error }) {
    state.errorFetchingNumbers = error;
    state.fetchingNumbers = false;
  },

  [mutationTypes.UPDATE_NUMBER](state, { phoneNumber, linkedNumber }) {
    state.numbersMap[phoneNumber] = linkedNumber;
  },

  [mutationTypes.UNLINK_NUMBER_FROM_CAMPAIGN](state, { phoneNumber }) {
    state.numbersMap[phoneNumber].campaignId = '';
    state.numbersMap[phoneNumber].status = CAMPAIGN_QUALIFICATION_STATUS.UNLINKED.value;
  },

  [mutationTypes.SHOW_NUMBERS_STATUS](state, showNumbersStatus) {
    state.showNumbersStatus = showNumbersStatus;
  },
  [mutationTypes.SHOW_BULK_SMS_NUMBERS_STATUS](state, showBulkSmsNumbersStatus) {
    state.showBulkSmsNumbersStatus = showBulkSmsNumbersStatus;
  },
};

export default mutations;
